import React, { useState } from "react";
import ArrowBack from "@images/profile/arrow_back.svg";
import RightArrow from "@images/profile/arrow_right.svg";
import ProfileHistory from "./ProfileHistory";
import ProfileAppeal from "./ProfileAppeal";
import { GavelIcon } from "@util/svgicon";

const ProfileWarning = ({ onclickWarning }) => {
  const [appeal, setAppeal] = useState("");

  const handaleWarning = () => {
    setAppeal("appealshow");
  };

  const warningData = [
    {
      label: "Ruling: 1st Warning",
      textColor: "text-black",
      bgcolor: "bg-[#FFB648]",
      detalis: [
        "Did not return to the origin point",
        "User chased after animals (Dogs, Cats, etc.) for a prolonged period of time.",
        "Disruption of local environment.",
      ],
    },
    {
      label: "Ruling: 2nd Warning",
      textColor: "text-white",
      bgcolor: "bg-red",
      detalis: [
        "Repeated 1st Warning error",
        "Disruption of local environment.",
        "Did not return to the origin point,User chased after animals (Dogs, Cats, etc.) for a prolonged period of time.",
        "Disruption of local environment.",
      ],
    },
  ];
  return (
    <>
      {appeal === "appealshow" ? (
        <ProfileAppeal onclick={() => setAppeal()} />
      ) : (
        <>
          <div className="flex justify-between items-center">
            <button
              onClick={onclickWarning}
              className="bg-black px-[12px] text-[16px] lenading-[24px] py-[10px] text-white flex gap-[4px] rounded-full"
            >
              <img src={ArrowBack} /> Go back
            </button>
            <div className="flex gap-[16px] mr-[100px]">
              <p className=" text-black font-medium	text-[16px] lenading-[24px]">Profile</p>
              <div>
                <img src={RightArrow} />
              </div>
              <p className="text-black font-medium text-[16px] lenading-[24px]">1st Warning</p>
            </div>
            <div />
          </div>
          <div className="max-w-[512px] mx-auto lg:mt-[56px] md:mt-[56px] mt-[16px] flex flex-col gap-[20px]">
            <p className="text-black text-[42px] leading-[42px] max-w-[406px] mx-auto font-semibold text-center">
              November 11, Mission 181
            </p>
            {warningData.map((item, index) => (
              <div className={`${item.bgcolor} p-[24px] rounded-2xl`} key={index}>
                <p className={`font-semibold ${item.textColor} text-[20px] leading-[28px]`}>
                  {item.label}
                </p>
                <ul className={`${item.textColor} pl-[19px]`}>
                  {item.detalis.map((key, index) => (
                    <li key={index} className="text-[16px] lenading-[24px] font-medium">
                      {key}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <ProfileHistory btnLabel="Send an appeal" btnIcon={<GavelIcon className="fill-white"/>} onClick={handaleWarning}/>
          </div>
        </>
      )}
    </>
  );
};

export default ProfileWarning;
